import { transactionTypes, type TransactionType } from "./utils";

/**
 *
 */
export type SamplingEnvConfig = {
  "page-load": { [pagecluster: string]: number[] | undefined };
  "http-request": { [pagecluster: string]: number | undefined };
};

/*                                  */
/**
 *
 *
 */
const pageLoadLive = {
"AftersalesOrders":[	1.00,	1.00,	1.00,	0.44,	0.25,	0.20,	0.21,	0.17,	0.15,	0.13,	0.11,	0.10,	0.11,	0.11,	0.10,	0.11,	0.13,	0.13,	0.15,	0.16,	0.19,	0.25,	0.44,	0.86,	],
"Artikeldetailseite":[	0.06,	0.08,	0.06,	0.04,	0.03,	0.02,	0.02,	0.02,	0.02,	0.02,	0.01,	0.01,	0.01,	0.01,	0.01,	0.01,	0.01,	0.01,	0.01,	0.01,	0.01,	0.01,	0.02,	0.04,	],
"BBS":[	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	0.76,	0.69,	0.79,	0.73,	0.66,	0.63,	0.66,	0.60,	0.61,	0.62,	0.71,	0.88,	1.00,	1.00,	],
"Checkout":[	1.00,	1.00,	1.00,	1.00,	0.88,	0.68,	0.74,	0.62,	0.50,	0.41,	0.33,	0.31,	0.35,	0.33,	0.30,	0.29,	0.29,	0.27,	0.27,	0.27,	0.30,	0.35,	0.66,	1.00,	],
"ConnectContact":[	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	0.89,	0.65,	0.61,	0.70,	0.70,	0.66,	0.72,	0.84,	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	],
"Einstiegsseite":[	0.83,	0.79,	0.68,	0.62,	0.52,	0.54,	0.79,	0.77,	0.61,	0.53,	0.45,	0.41,	0.48,	0.41,	0.44,	0.33,	0.35,	0.36,	0.36,	0.37,	0.40,	0.37,	0.74,	0.80,	],
"Kundenbewertungsseite":[	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	0.83,	0.70,	0.58,	0.52,	0.56,	0.53,	0.50,	0.46,	0.47,	0.41,	0.40,	0.40,	0.42,	0.50,	1.00,	1.00,	],
"Login":[	1.00,	1.00,	1.00,	0.81,	0.41,	0.30,	0.33,	0.28,	0.23,	0.20,	0.17,	0.15,	0.18,	0.17,	0.16,	0.16,	0.19,	0.18,	0.19,	0.20,	0.24,	0.33,	0.60,	1.00,	],
"MYA_Dashboard":[	1.00,	1.00,	0.70,	0.33,	0.21,	0.18,	0.22,	0.19,	0.17,	0.14,	0.12,	0.11,	0.13,	0.12,	0.12,	0.12,	0.12,	0.13,	0.15,	0.15,	0.18,	0.22,	0.37,	0.70,	],
"MYA_Invoices":[	1.00,	1.00,	1.00,	0.41,	0.26,	0.23,	0.27,	0.25,	0.22,	0.19,	0.16,	0.16,	0.18,	0.17,	0.16,	0.17,	0.18,	0.19,	0.21,	0.22,	0.26,	0.33,	0.56,	1.00,	],
"MYA_Orders":[	1.00,	1.00,	0.74,	0.34,	0.20,	0.16,	0.16,	0.14,	0.12,	0.10,	0.08,	0.08,	0.09,	0.09,	0.09,	0.09,	0.10,	0.11,	0.12,	0.14,	0.16,	0.22,	0.38,	0.75,	],
"Paymentinfo":[	1.00,	1.00,	1.00,	0.65,	0.40,	0.33,	0.38,	0.34,	0.30,	0.26,	0.22,	0.21,	0.23,	0.22,	0.21,	0.22,	0.24,	0.24,	0.28,	0.30,	0.36,	0.45,	0.78,	1.00,	],
"Produktliste":[	0.38,	0.42,	0.42,	0.26,	0.18,	0.15,	0.18,	0.17,	0.14,	0.11,	0.09,	0.08,	0.09,	0.08,	0.08,	0.06,	0.05,	0.06,	0.06,	0.06,	0.07,	0.08,	0.15,	0.25,	],
"Storefront":[	0.26,	0.29,	0.24,	0.13,	0.10,	0.09,	0.10,	0.09,	0.08,	0.07,	0.06,	0.05,	0.06,	0.05,	0.05,	0.05,	0.05,	0.05,	0.05,	0.05,	0.06,	0.07,	0.11,	0.20,	],
"Suchergebnisseite":[	0.16,	0.21,	0.21,	0.13,	0.08,	0.07,	0.08,	0.06,	0.05,	0.04,	0.03,	0.03,	0.03,	0.03,	0.03,	0.03,	0.03,	0.02,	0.02,	0.02,	0.02,	0.03,	0.05,	0.10,	],
"Warenkorb":[	0.62,	0.71,	0.63,	0.35,	0.21,	0.18,	0.21,	0.18,	0.15,	0.12,	0.10,	0.09,	0.10,	0.10,	0.09,	0.09,	0.08,	0.08,	0.08,	0.08,	0.08,	0.10,	0.19,	0.37,	],
"Wishlist":[	1.00,	1.00,	1.00,	0.56,	0.35,	0.29,	0.35,	0.31,	0.26,	0.22,	0.18,	0.16,	0.18,	0.17,	0.16,	0.15,	0.14,	0.14,	0.14,	0.14,	0.15,	0.19,	0.33,	0.68,	],
"test":[	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	1.00,	0.81,	0.62,	0.58,	0.64,	0.60,	0.54,	0.51,	0.49,	0.45,	0.44,	0.42,	0.45,	0.53,	1.00,	1.00,	],
};
/*                                 */

/**
 *
 *
 *
 */
const liveHttpRequest = {
  Errorseite404: 0.21,
  Login: 1.0, /*  */
  Registration: 0.15,
  Produktliste: 0.09,
  Storefront: 0.65,
  Suchergebnisseite: 0.07,
};

/**
 *
 *
 */
export const sampligRates: Record<"live" | "develop", SamplingEnvConfig> = {
  live: {
    [transactionTypes[0]]: pageLoadLive,
    [transactionTypes[1]]: liveHttpRequest,
  },
  develop: { [transactionTypes[0]]: {}, [transactionTypes[1]]: {} },
};

export const getSamplingRate = (
  type: TransactionType,
  pagecluster: string,
  now = new Date(),
  env = import.meta.env.VITE_OTTO_INSTALLATION_ENV,
): number => {
  const current = now.getUTCHours(); /*          */
  const rates = sampligRates[env];

  if (type === "page-load") {
    const { [pagecluster]: pcRates = [] } = rates[type];
    return pcRates[current] ?? 1;
  }

  return rates[type][pagecluster] ?? 1;
};
